import React from 'react';
import { Route } from 'react-router-dom';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { RoutePathProps } from '../../../AppRoutes/types';
import PriceCode from '../pages/PriceCode';
import { addChildRoute } from '../../../AppRoutes/utils';
import Setting from '../pages/Setting';

const priceCode: RoutePathProps = {
  name: "priceCode",
  path: "/priceCode",
  label: "Price Code",
  icon: MonetizationOnIcon,
  visibleInNav: true,
  requiredPermission:'price-code:read',
  children: [
    // {
    //   name: "priceCode",
    //   path: "/priceCode",
    //   label: "Price Code",
    //   icon: SettingsOutlinedIcon,
    // },
    // {
    //   name: "addProduct",
    //   path: "/inventory/addProduct",
    //   label: "Add Product",
    //   icon: InfoIcon,
    // },
    // {
    //   name: "editProduct",
    //   path: "/inventory/editProduct/:id",
    //   label: "Edit Product",
    //   icon: InfoIcon,
    // },
  ],
};

const setting: RoutePathProps = {
  name: "setting",
  path: "/setting",
  label: "Setting",
  icon: SettingsSuggestIcon,
  visibleInNav: true,
  requiredPermission:'settings:view',
  children: [
   
  ],
};



const controlPanel: RoutePathProps = addChildRoute(
    {
    name: 'controlPanel',
    path: '/controlPanel',
    label: 'Control Panel',
    visibleInNav: true,
    icon: SettingsOutlinedIcon,
    dummy: true,
    children: [priceCode, setting],
    requiredPermission:'control-panel:list'
  },
  { priceCode , setting}
)

const ControlPanelRoutes = (
  <>
    <Route path={controlPanel.path} element={<Setting />} />
     <Route path={controlPanel.children?.[0].path} element={<PriceCode />} />
     <Route path={controlPanel.children?.[1].path} element={<Setting />} />
    {/* <Route path={inventory.children?.[1].path} element={<AddProduct />} /> */}
    {/* <Route path={inventory.children?.[2].path} element={<EditProduct />} />  */}
  </>
);
export const controlPanelPaths = [controlPanel];
export default ControlPanelRoutes;
